export default __webpack_public_path__ + "static/media/mysql-negative.a08793be.svg";